<template>
    <section>
        <o-field>
            <o-checkbox size="small" label="Small" />
        </o-field>

        <o-field>
            <o-checkbox label="Default" />
        </o-field>

        <o-field>
            <o-checkbox size="medium" label="Medium" />
        </o-field>

        <o-field>
            <o-checkbox size="large" label="Large" />
        </o-field>
    </section>
</template>
